import { PAGE_SIZE } from '../config';
import { filtersService } from './filters.service';

export class TableService {
	getFilteredRows(rows, pages) {
		let filteredRows = [];
		let start = pages[0] * PAGE_SIZE;
		let stop = start + pages.length * PAGE_SIZE;

		for (var i = start; i < stop; i++) {
			filteredRows[i] = rows[i];
		}

		return filteredRows;
	}

	getDataToLoad(startIndex, stopIndex, allocatedData) {
		const pagesInMemory = this.rowsToPages(allocatedData);
		// definisco le pagine in cui mi trovo
		let startPage = this.indexToPage(startIndex);
		let stopPage = this.indexToPage(stopIndex);
		let pagesNumbers = stopPage - startPage + 1;
		let pageToLoad = [];

		for (var i = 0; i < pagesNumbers; i++) {
			let page = startPage + i;
			if (!pagesInMemory.includes(page)) pageToLoad.push(page);
		}

		let count = PAGE_SIZE * pageToLoad.length;
		let start = pageToLoad[0] * PAGE_SIZE;

		return {
			start: start,
			count: count
		};
	}

	rowsToPages(rows = []) {
		let pages = [];

		rows.forEach((value, index) => {
			let page = this.indexToPage(index);
			if (!pages.includes(page)) pages.push(page);
		});

		return pages;
	}

	rowsByPages(rows = [], pages = []) {
		let result = [];

		let i = pages[0] * PAGE_SIZE;
		const max = (pages[pages.length - 1] + 1) * PAGE_SIZE;

		for (i; i < max; i++) {
			result[i] = rows[i];
		}

		return result;
	}

	indexToPage(index) {
		let value = index / PAGE_SIZE;

		return Math.trunc(value);
	}

	checkDefaultParams(sort, filters, search) {
		let dSort =
			sort &&
			(sort?.options?.find(x => x?.default)?.value ||
				sort?.find(x => x?.default)?.value ||
				null);
		let dFilters = filtersService.getDefault(filters);

		return {
			sort: dSort,
			filters: dFilters
		};
	}
}

export const tableService = new TableService();
